import { lazy } from 'react';

const Products = lazy(() => import('./Products/products'));

const BuildAGraphConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: 'agent_journeys',
      element: <Products />,
    }
  ],
};

export default BuildAGraphConfig;
